// extracted by mini-css-extract-plugin
export default {"journal-entry-header":"JournalEntryReport_journal-entry-header__YxGZO","divider":"JournalEntryReport_divider__1kBel"};